import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { EndPoints } from '../EndPoints';
import { WarehouseExtraServiceDataForm, WarehouseExtraServiceFilters } from '../../models/WareHouseQuoteExtraService';
import { ServiceEvents } from '../shared/interfaces';

const useWarehouseQuoteExtraService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetWarehouseExtraServices, setFetchingGetWarehouseExtraServices] = useState(false);
    const [fetchingStoreWarehouseExtraService, setFetchingStoreWarehouseExtraService] = useState(false);
    const [fetchingUpdateWarehouseExtraService, setFetchingUpdateWarehouseExtraService] = useState(false);
    const [fetchingDeleteWarehouseExtraService, setFetchingDeleteWarehouseExtraService] = useState(false);
    const [fetchingShowWarehouseExtraService, setFetchingShowWarehouseExtraService] = useState(false);
    const [fetchingEditWarehouseExtraService, setFetchingEditWarehouseExtraService] = useState(false);
    const [fetchingCreateWarehouseExtraService, setFetchingCreateWarehouseExtraService] = useState(false);

    const getAllWarehouseExtraServicesByQuote = (
        quoteId: number,
        extraServiceFilters: WarehouseExtraServiceFilters,
        events: ServiceEvents = {}

    ) => {
       
        const queryString = Object.entries(extraServiceFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_QUOTES.GET_WAREHOUSE_EXTRA_SERVICES}?${queryString}`;
       
        doGet({
            ...events,
            url: url.replace(
                ':quote_id',
                quoteId.toString()
            ),
            setFetching: setFetchingGetWarehouseExtraServices
        });
    };

    const showWarehouseExtraService = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.SHOW_WAREHOUSE_EXTRA_SERVICE.replace(':id', id.toString()),
            setFetching: setFetchingShowWarehouseExtraService
        });
    };

    const storeWarehouseExtraService = (
        data: WarehouseExtraServiceDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            url: EndPoints.WAREHOUSE_QUOTES.STORE_WAREHOUSE_EXTRA_SERVICE,
            body: data,
            setFetching: setFetchingStoreWarehouseExtraService,
            ...events
        });
    };

    const updateWarehouseExtraService = (
        id: number,
        data: WarehouseExtraServiceDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.UPDATE_WAREHOUSE_EXTRA_SERVICE.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdateWarehouseExtraService
        });
    };

    const deleteWarehouseExtraService = (
        id: number,
        events: ServiceEvents = {}
    ) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.DELETE_WAREHOUSE_EXTRA_SERVICE.replace(':id', id.toString()),
            setFetching: setFetchingDeleteWarehouseExtraService
        });
    };

    const createWarehouseExtraService = (quoteId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.CREATE_WAREHOUSE_EXTRA_SERVICE.replace(':quote_id', quoteId.toString()),
            setFetching: setFetchingCreateWarehouseExtraService
        });
    };

    const editWarehouseExtraService = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_QUOTES.EDIT_WAREHOUSE_EXTRA_SERVICE.replace(':id', id.toString()),
            setFetching: setFetchingEditWarehouseExtraService
        });
    };

    return {
        getAllWarehouseExtraServicesByQuote,
        showWarehouseExtraService,
        storeWarehouseExtraService,
        updateWarehouseExtraService,
        deleteWarehouseExtraService,
        createWarehouseExtraService,
        editWarehouseExtraService,

        fetchingGetWarehouseExtraServices,
        fetchingStoreWarehouseExtraService,
        fetchingUpdateWarehouseExtraService,
        fetchingDeleteWarehouseExtraService,
        fetchingShowWarehouseExtraService,
        fetchingCreateWarehouseExtraService,
        fetchingEditWarehouseExtraService
    };
};

export default useWarehouseQuoteExtraService;
